<dgx-user-recommendation-header [item]="userRecHeaderItem" [maxLines]="2">
</dgx-user-recommendation-header>

<dgx-tile-launcher
  [recommendationInfo]="userRecHeaderItem"
  [actionContext]="item"
  [isIframe]="isIframe"
  [section]="section"
  [lazyChunkIndex]="lazyChunkIndex"
  [tileIndex]="itemIndex"
  [expandCard]="
    contentCardService.shouldLazyLoadedCardExpand(
      itemIndex,
      lazyChunkIndex,
      section
    ) | async
  "
  [item]="item.reference"
  [initialTagAction]="item.action"
  (dismiss)="onDismiss(item)"
  opportunityDescriptionLength="short"
  [modifyOptionsFn]="modifyOptionsFn"
  (dismissTagRecommendation)="dismiss()"
></dgx-tile-launcher>
